<template>
  <div>
    <vs-prompt
      :title="titleText"
      @cancel="val = ''"
      @accept="acceptAddNewEventsPrompt"
      @close="closeAddNewEventsPrompt"
      :active.sync="addNewEventPrompt"
      :accept-text="titleText"
      :is-valid="validForm"
      class="eventPopup"
    >
      <vs-row>
        <vs-col vs-w="7">
          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/5 w-full">
              <span>Title</span>
            </div>
            <div class="vx-col sm:w-4/5 w-full">
              <vs-input class="inputx w-full" placeholder="Title" v-model="event_title" />
            </div>
          </div>
          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/5 w-full">
              <span>Category</span>
            </div>

            <div class="vx-col sm:w-2/5">
              <vs-select v-model="event_category">
                <vs-select-item
                  :key="index"
                  :value="item"
                  :text="item"
                  v-for="(item, index) in category_list"
                />
              </vs-select>
            </div>
          </div>

          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/5 w-full">
              <span>Content text</span>
            </div>
            <div class="vx-col sm:w-4/5 w-full">
              <vs-textarea
                v-model="event_description"
                placeholder="Content text"
                class="w-full"
                height="150px"
              />
            </div>
          </div>
          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/5 w-full">
              <span>Ticket Link</span>
            </div>
            <div class="vx-col sm:w-4/5 w-full">
              <vs-input class="inputx w-full" placeholder="Ticket link" v-model="event_ticketLink" />
            </div>
          </div>

          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/5 w-full">
              <span>Start & end date</span>
            </div>
            <div class="vx-col sm:w-2/5 w-full">
              <flat-pickr
                class="p-3 s-inputx vs-input--input flex"
                :config="datePickerConfigStart"
                v-model="event_startDate"
                placeholder="Start..."
                style="display: flex; width: 100%"
              />
            </div>
            <div class="vx-col sm:w-2/5 w-full">
              <flat-pickr
                class="p-3 s-inputx vs-input--input flex"
                :config="datePickerConfig"
                v-model="event_endDate"
                placeholder="End..."
                style="display: flex; width: 100%"
              />
            </div>
          </div>

          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/5 w-full">
              <span>Recurring</span>
            </div>
            <div class="vx-col sm:w-2/5 w-full">
              <vs-checkbox v-model="isRecurring">Recurring</vs-checkbox>
            </div>
          </div>
          <transition name="fade">
            <div class="vx-row mb-6" v-if="isRecurring">
              <div class="vx-col sm:w-1/5 w-full">
                <span>Days</span>
              </div>
              <div class="vx-col sm:w-4/5 w-full" style="display: flex">
                <vs-checkbox
                  v-for="(day, index) in recurringDays"
                  :key="index"
                  v-model="selectedRecurringDays"
                  :vs-value="day.id"
                  >{{ day.name }}</vs-checkbox
                >
              </div>
            </div>
          </transition>

          <transition name="fade">
            <div class="vx-row mb-6" v-if="isRecurring">
              <div class="vx-col sm:w-1/5 w-full"></div>
              <div class="vx-col sm:w-4/5 w-full">
                <span style="color: #ccc">Repeats {{ recurringText }}</span>
              </div>
            </div>
          </transition>

          <!--<div class="vx-row mb-6">
        <div class="vx-col sm:w-1/5 w-full">
          <span>Responsible</span>
        </div>
        <div class="vx-col">
          <vs-input
            class="inputx w-full"
            placeholder="Full name"
            v-model="event_responsible"
          />
        </div>
      </div>-->

          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/5 w-full">
              <span>Responsible</span>
            </div>
            <div class="vx-col sm:w-3/5 w-full">
              <TypeAhead
                v-model="data"
                classes="typeahead-container"
                :placeholder="placeholder"
                src=""
                :getResponse="getResponse"
                :selectFirst="selectFirst"
                :limit="parseInt(limit)"
                :queryParamName="queryParamName"
                :minChars="parseInt(minChars)"
                :delayTime="parseInt(delayTime)"
                :onHit="onHit"
                :highlighting="highlighting"
                :render="render"
                :fetch="fetch"
              ></TypeAhead>

              <div v-if="event_responsible_name !== ''">
                <vs-chip v-if="event_responsible_userId !== ''" color="success" class="mt-6 instructor-chip">
                  {{ event_responsible_name }}
                </vs-chip>
              </div>
            </div>
          </div>

          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/5 w-full">
              <span>Tags</span>
            </div>
            <div class="vx-col sm:w-4/5">
              <vs-chips placeholder="New Tag" v-model="event_tags">
                <vs-chip @click="remove(chip)" :key="chip" v-for="chip in event_tags" closable>
                  {{ chip }}
                </vs-chip>
              </vs-chips>
            </div>
          </div>

          <div class="buttons-footer-left">
            <vs-button
              v-if="event_id !== ''"
              color="danger"
              @click.native="confirmDelete"
              :type="!isRecurring ? 'border' : 'filled'"
              class=""
              >Delete{{ isRecurring ? "" : "" }}</vs-button
            >

            <vs-button
              v-if="event_id !== '' && isRecurring"
              color="danger"
              @click.native="deleteThisDay"
              type="border"
              class="ml-2"
              >Delete{{ isRecurring ? " this only" : "" }}</vs-button
            >
          </div>
        </vs-col>
        <vs-col vs-w="5" class="px-5" style="padding-left: 60px" vs-justify="center">
          <vs-row vs-justify="center">
            <h3 class="mb-3">Marketing Actions</h3>
            <vs-list>
              <vs-list-item
                v-for="smc in smcEvents"
                :key="smc.id"
                :title="smc.title"
                :subtitle="`${getSMCPlatformType(smc)} - ${smc.meta.price} ${currencyCode}`"
                class="smc-list-item mb-4"
                @click.native="
                  $refs.popupAddSoMe.showWith(smc, null, addSoMeCallback);
                  addNewEventPrompt = false;
                "
              >
                <template slot="avatar">
                  <img
                    :src="require(`@/assets/images/smc/${smc.meta.platform}.png`)"
                    width="32"
                    height="32"
                    class="rounded-full block mr-3"
                  />
                </template>
              </vs-list-item>
            </vs-list>
          </vs-row>
          <vs-row vs-justify="center">
            <vs-button
              icon="add"
              vs-justify="center"
              @click.native="
                $refs.popupAddSoMe.show(null, true, addSoMeCallback);
                addNewEventPrompt = false;
              "
              >Social</vs-button
            >
            <vs-button
              icon="add"
              class="ml-2"
              vs-justify="center"
              @click.native="
                $refs.popupAddSoMe.show(null, false, addSoMeCallback);
                addNewEventPrompt = false;
              "
              >Paid Media</vs-button
            >
          </vs-row>
        </vs-col>
      </vs-row>
    </vs-prompt>

    <popup-add-so-me ref="popupAddSoMe" />
  </div>
</template>

<script>
import flatPickr from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
import moment from "moment";
import PopupAddSoMe from "./PopupAddSoMe.vue";

import { mapGetters } from "vuex";
import { RRule, RRuleSet, rrulestr } from "rrule";
import TypeAhead from "vue2-typeahead";

export default {
  components: {
    TypeAhead,
    flatPickr,

    PopupAddSoMe,
  },
  data() {
    const that = this;
    return {
      // Typeahead
      smcEvents: [],
      data: "",
      selectFirst: false,
      limit: 10,
      queryParamName: ":keyword",
      minChars: 2,
      delayTime: 500,
      placeholder: "Please enter responsible name or email",
      classes: "typeahead",

      calendarClickedDate: null,
      exclusionDays: [],
      rruleConfig: {
        freq: RRule.WEEKLY,
        //interval: 5,
        //byweekday: [RRule.MO, RRule.FR],
        //dtstart: new Date(Date.UTC(2012, 1, 1, 10, 30)),
        //until: new Date(Date.UTC(2012, 12, 31)),
      },
      event_rrule: null,
      momentFormat: "DD-MM-YYYY", // "DD-MM-YYYY HH:mm" for time
      smc_platform: 0,
      smc_type: 0,
      smc_cost: 0,
      category_list: [
        "Live Music",
        "Live Artist",
        "Bingo",
        "Quiz",
        "Jam ",
        "Stand-up",
        "Beer Pong",
        "Artist",
        "Sport",
        "Other event",
      ],
      selectedRecurringDays: [],
      recurringDays: [
        { id: 0, name: "Mon" },
        { id: 1, name: "Tue" },
        { id: 2, name: "Wed" },
        { id: 3, name: "Thu" },
        { id: 4, name: "Fri" },
        { id: 5, name: "Sat" },
        { id: 6, name: "Sun" },
      ],
      list: {
        Facebook: [
          { value: 0, text: "Feed" },
          { value: 1, text: "Story" },
          { value: 2, text: "Event" },
          { value: 2, text: "Competition" },
        ],
        Instagram: [
          { value: 0, text: "Feed" },
          { value: 1, text: "IGTV" },
          { value: 1, text: "Story" },
          { value: 1, text: "Competition" },
        ],
        Youtube: [{ value: 0, text: "Video" }],
        App: [{ value: 0, text: "Message" }],
        SMS: [{ value: 0, text: "Message" }],

        Newsletter: [{ value: 0, text: "Link" }],
        Other: [{ value: 0, text: "Other" }],
      },
      event_id: "",
      event_title: "",
      event_description: "",
      event_category: "",
      event_ticketLink: "",
      event_startDate: null,
      event_endDate: null,
      event_type: 0,
      isRecurring: false,
      event_responsible_name: "",
      event_responsible_userId: "",
      event_tags: [],
      event_connected_event_ids: [],
      addNewEventPrompt: false,
      datePickerConfig: {
        enableTime: false, // Set to true for time again
        enableSeconds: false,
        noCalendar: false,
        time_24hr: true,
        dateFormat: "d-m-Y", // "d-m-Y H:i" for time
        defaultHour: 12,
        defaultMinute: 30,
        defaultSecond: 0,
      },
      datePickerConfigStart: {
        enableTime: false, // Set to true for time again
        enableSeconds: false,
        noCalendar: false,
        time_24hr: true,
        dateFormat: "d-m-Y", // "d-m-Y H:i" for time
        defaultHour: 12,
        defaultMinute: 30,
        defaultSecond: 0,
        onChange: function (selectedDates) {
          that.updateEndDate();
        },
      },
      currencyMap: {
        Danmark: "DKK",
        Finland: "EUR",
        Norge: "NOK",
        England: "GBP",
      },
    };
  },
  computed: {
    ...mapGetters({
      activeVenue: "venues/activeVenue",
      userId: "users/userId",
      event: "activationPlan/event",
    }),
    currencyCode() {
      return this.currencyMap[this.activeVenue.country];
    },
    validForm() {
      return (
        this.event_title !== "" &&
        this.event_category !== "" &&
        this.event_startDate !== "" &&
        this.event_endDate !== "" &&
        (moment(this.event_endDate, this.momentFormat).isAfter(
          moment(this.event_startDate, this.momentFormat),
        ) ||
          moment(this.event_endDate, this.momentFormat).isSame(
            moment(this.event_startDate, this.momentFormat),
          ))
      );
    },
    titleText() {
      return (this.event_id !== "" ? "Update " : "Add ") + "Activity";
    },

    recurringText() {
      const rrule = new RRule({
        ...this.rruleConfig,
        byweekday: this.selectedRecurringDays,
        dtstart: moment.utc(this.event_startDate, this.momentFormat).toDate(),
        until: new Date(moment.utc(this.event_endDate, this.momentFormat).format()),
      });
      return rrule.toText();
    },
  },
  methods: {
    addSoMeCallback(soMeId) {
      this.addNewEventPrompt = true; // Show this popup again
      if (soMeId) {
        const eventData = this.event(soMeId);
        console.log("Event returned callback", eventData);
        if (!this.event_connected_event_ids.includes(soMeId)) {
          this.event_connected_event_ids.push(soMeId);
          this.smcEvents.push(eventData);
        }
      }
    },
    getSMCPlatformType(event) {
      if (!event.meta.platform || !event.meta.type) {
        return "";
      }
      const found = this.list[event.meta.platform].find(e => e.value == event.meta.type);
      if (!found || !found.text) return "";
      return found.text;
    },
    getResponse: function (response) {
      return response.data;
    },
    onHit: function (item, vue /*, index*/) {
      let current = vue.current;
      let selectedItem = vue.data[current];

      this.event_responsible_userId = selectedItem.userId;
      this.event_responsible_name = item;
    },
    highlighting: function (item, vue) {
      return item.toString().replace(vue.query, `<b>${vue.query}</b>`);
    },
    render: function (items /*, vue*/) {
      const titles = items.map(x => x.firstName + " " + x.lastName + " (" + x.email + ")");
      return titles;
    },
    fetch: function (/*url*/) {
      return this.$http.get(process.env.VUE_APP_API_BASE_URL + "/users?query=" + this.data);
    },

    updateEndDate() {
      this.event_endDate = this.event_startDate;
    },
    async deleteThisDay() {
      this.exclusionDays.push(this.calendarClickedDate);
      await this.acceptAddNewEventsPrompt();
      this.addNewEventPrompt = false;
      //console.log("Exclusion days now", this.exclusionDays);
    },
    confirmDelete() {
      this.addNewEventPrompt = false;
      this.$vs.dialog({
        type: "confirm",
        color: "danger",
        title: `Confirm`,
        text: "Delete event?",
        accept: this.deleteEvent,
      });
    },
    async deleteEvent() {
      console.log("Deleting event");
      this.$vs.loading();
      await this.$store.dispatch("activationPlan/deleteEvent", {
        eventId: this.event_id,
        venueId: this.activeVenue.venueId,
      });

      this.$vs.loading.close();
      this.$vs.notify({
        color: "danger",
        title: "Deleted event",
        text: "The event was deleted",
      });
    },
    show(dates) {
      this.event_type = 0; // type
      this.event_connected_event_ids = [];
      this.addNewEventPrompt = true;
      // reset form
      this.data = "";
      this.calendarClickedDate = null;
      this.exclusionDays = [];
      this.event_rrule = null;
      this.smc_platform = 0;
      this.smc_type = 0;
      this.smc_cost = 0;
      this.selectedRecurringDays = [];
      this.event_id = "";
      this.event_title = "";
      this.event_description = "";
      this.event_category = "";
      this.event_ticketLink = "";

      this.isRecurring = false;
      this.event_responsible_name = "";
      this.event_responsible_userId = "";
      this.event_tags = [];

      if (dates) {
        this.event_startDate = moment(dates.start).format(this.momentFormat);
        this.event_endDate = moment(dates.end).subtract(1, "days").format(this.momentFormat);
      } else {
        this.event_startDate = null;
        this.event_endDate = null;
      }
    },
    showWith(data, ccd) {
      this.calendarClickedDate = moment.utc(ccd).toDate();

      this.event_id = data.activationPlanEventId;

      if (data.connectedEventIds) {
        this.event_connected_event_ids = data.connectedEventIds;
        this.smcEvents = data.connectedEventIds.map(soMeId => this.event(soMeId)).filter(e => e); // If the event is undefined, filter it out (it has been deleted)
      } else {
        this.event_connected_event_ids = [];
        this.smcEvents = [];
      }

      this.event_title = data.title;
      this.event_category = data.category;
      this.event_ticketLink = data.ticketLink;
      this.event_type = data.type;
      this.isRecurring = data.isRecurring;
      //this.rExclusionDates = data.rExclusionDatesUtcTicks;
      if (this.isRecurring) {
        const tRuleSet = rrulestr(data.rRule, { forceset: true });
        const tRule = tRuleSet.rrules()[0]; // important: assumes only one rule per set
        this.selectedRecurringDays = tRule.options.byweekday;
        this.exclusionDays = tRuleSet.exdates();
      }
      //this.selectedRecurringDays = data.rWeekDays;
      this.event_description = data.description;
      this.event_startDate = moment(data.startDateUtcTicks).format(this.momentFormat);
      this.event_endDate = moment(data.endDateUtcTicks).format(this.momentFormat);
      this.event_tags = data.tags;
      this.event_responsible_name = data.meta ? data.meta["responsibleName"] : "";
      this.event_responsible_userId = data.meta ? data.meta["responsibleUserId"] : "";
      if (data.type === 1) {
        this.smc_cost = parseInt(data.meta["price"]);
        this.smc_platform = data.meta["platform"];
        this.smc_type = parseInt(data.meta["type"]);
      }
      this.addNewEventPrompt = true;
    },
    remove(item) {
      this.event_tags.splice(this.event_tags.indexOf(item), 1);
    },
    async acceptAddNewEventsPrompt() {
      const event = {
        title: this.event_title,
        description: this.event_description,
        category: this.event_category,
        ticketLink: this.event_ticketLink,
        type: this.event_type, // 0 for activity, 1 for SMC
        startDate: moment(this.event_startDate, this.momentFormat).format(), // valueOf for unix
        endDate: moment(this.event_endDate, this.momentFormat).format(),
        userId: this.userId,
        isRecurring: this.isRecurring,
        //rWeekDays: this.selectedRecurringDays,
        venueId: this.activeVenue.venueId,
        //rExclusionDates: this.rExclusionDates,
        tags: this.event_tags,
        connectedEventIds: this.event_connected_event_ids,
        meta: {
          platform: `${this.smc_platform}`,
          price: `${this.smc_cost}`,
          type: `${this.smc_type}`,
          currency: this.currencyCode,
          responsibleName: this.event_responsible_name,
          responsibleUserId: this.event_responsible_userId,
        },
      };

      if (this.isRecurring) {
        const rrule = new RRule({
          ...this.rruleConfig,
          byweekday: this.selectedRecurringDays,
          dtstart: moment.utc(this.event_startDate, this.momentFormat).toDate(),
          until: new Date(moment.utc(this.event_endDate, this.momentFormat).format()),
        });

        const rruleSet = new RRuleSet();

        // Add a rrule to rruleSet
        rruleSet.rrule(rrule);
        this.exclusionDays.forEach(e => rruleSet.exdate(e));

        event.rrule = rruleSet.toString();
      }

      this.$vs.loading();
      if (this.event_id !== "") {
        console.log("Updating event", event);
        event.id = this.event_id;
        await this.$store.dispatch("activationPlan/updateEvent", event);
        this.$vs.notify({
          color: "success",
          title: "Activity updated",
          text: "Your Activity was updated",
        });
      } else {
        console.log("Adding event", event);
        await this.$store.dispatch("activationPlan/addEvent", event);
        this.$vs.notify({
          color: "success",
          title: "Activity added",
          text: "Your Activity was added",
        });
      }
      this.$vs.loading.close();
    },
    closeAddNewEventsPrompt() {},
  },
};
</script>

<style lang="scss" >
@keyframes fadeIn {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}

.smc-list-item {
  background: white;
  border-radius: 8px;
  border: 1px #efefef solid;
  box-shadow: 0 4px 12px 0 rgba(0, 0, 0, 0.1);
  cursor: pointer;
  transition: all 0.2s ease;

  &:hover {
    transform: translateY(-5px);
  }
}

.con-chips--remove-all {
  display: none;
}

.buttons-footer-left {
  position: absolute;
  bottom: 14px;
  z-index: 100;
  animation: fadeIn ease 500ms forwards;
  animation-delay: 500ms;
  opacity: 0;
}

.eventPopup.con-vs-dialog .vs-dialog {
  max-width: 1080px !important;
  position: relative;
}

.vs-select--label {
  font-size: 0.85rem;
  color: rgba(0, 0, 0, 0.6) !important;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}

.typeahead-container input {
  padding: 0.7rem !important;
  font-size: 1rem !important;
  color: inherit;
  position: relative;
  padding: 0.4rem;
  border-radius: 5px;
  border: 1px solid rgba(0, 0, 0, 0.2);
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  -webkit-box-shadow: 0 0 0 0 rgba(0, 0, 0, 0.15);
  box-shadow: 0 0 0 0 rgba(0, 0, 0, 0.15);
  -webkit-transition: all 0.3s ease;
  transition: all 0.3s ease;
  width: 100%;
}

.instructor-chip {
  font-size: 14px;
}
.horizontal-row {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  -webkit-box-pack: start;
  -ms-flex-pack: start;
  justify-content: flex-start;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
}
</style>
